// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RequestFormPagingResultModel from '../../model/request-form-paging-result-model';
import RequestFormPagingResultDTO from '../dto/request-form-paging-result-dto';
import dtoSchema from '../schemas/request-form-paging-result-schema';
import RequestFormModel from '../../model/request-form-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class RequestFormPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RequestFormPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => RequestFormModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: RequestFormModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<RequestFormPagingResultDTO>): RequestFormPagingResultModel;
  static toModel(dto: DeepPartial<RequestFormPagingResultDTO> | undefined | null): RequestFormPagingResultModel | undefined;
  static toModel(dto: DeepPartial<RequestFormPagingResultDTO> | undefined | null): RequestFormPagingResultModel | undefined {
    return dto ? new RequestFormPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RequestFormPagingResultModel> | RequestFormPagingResultModel): RequestFormPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as RequestFormPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RequestFormPagingResultModel, can not map to RequestFormPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
